import { useModelFilterSelector } from "../redux/store";
import {
    type CreateFinanceMinMaxType,
    createFinanceMinMax,
} from "../../../shared-logic/utils/legalBannerDisclaimerUtils";
import type { LegalBannerDisclaimerDataType } from "../../../shared-logic/types/FinanceTypes";
import type { PriceType } from "../../../../common-deprecated/types/CommonTypes";
import { showLegalBannerDisclaimer } from "../../../../common-deprecated/settings/utils/commonSettingUtils";

const useDisclaimerContent = (): LegalBannerDisclaimerDataType | null => {
    const { initialized, results } = useModelFilterSelector((state) => state.modelResults);
    const hasNLFinanceDisclaimer = useModelFilterSelector((state) => showLegalBannerDisclaimer(state.commonSettings));

    if (!initialized || !hasNLFinanceDisclaimer) return null;

    const tableInput = results.reduce<CreateFinanceMinMaxType<PriceType>>((acc, result) => {
        if (result.cheapestCarMonthly) {
            acc.push(result.cheapestCarMonthly);
        }
        return acc;
    }, []);

    if (tableInput.length) {
        return createFinanceMinMax(tableInput);
    }

    return null;
};
export default useDisclaimerContent;
